<template style="background-color: #fff">
  <div>
    <loading-screen v-if="!$vuetify.breakpoint.smAndDown && !isPublicRoute"></loading-screen>
    <v-app v-if="(logged && current_user) || isPublicRoute" :style="isPublicRoute ? '' : background">        
      <div v-if="!isPublicRoute" id="back_menu"></div>
      <!-- Content for sm and up -->
      <v-flex v-if="!isPublicRoute && result[0] == 'ie'" id="topmenu"></v-flex>
      <ApiMenu v-if="!isPublicRoute && result[0] == 'ie'" style="position: fixed; z-index: 99;" />
      <v-flex v-if="!isPublicRoute && result[0] !== 'ie' && windowWidth <= '400px'" style="width: 100%;" id="topmenu"></v-flex>
      <ApiMenu
        v-if="!isPublicRoute && result[0] !== 'ie' && $vuetify.breakpoint.mdAndUp"
        style="position: absolute; top: 0; z-index: 9; background-color: #fff;"
      />
      <div :style="isPublicRoute ? '' : background" >
        <MenuMobile v-if="!isPublicRoute" id="topmenu" style="padding-bottom: 3em;"/>
        <v-content :style="isPublicRoute ? '' : (result[0] == 'ie' ? 'margin-top: 75px' : paddingTop)">
          <transition
            name="reouter-anim"
            :duration="{enter: 300, leave: 300}"
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOutRight"
            mode="out-in"
          >
            <router-view :class="getClassRouterView" />
          </transition>
        </v-content>

        <!-- notifications button  -->
        <!-- <v-layout column class="fab-container">
          <v-tooltip top v-if="notificationListOpen==false" >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-show="!hidden"
                id="btnTop"
                ref="button"
                @click="onHelpcenter"
                fab
                v-bind="attrs"
                v-on="on"
              >
                <v-img
                   src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/icon-helpcenter-green.png"
                ></v-img>
              </v-btn>
            </template>
            <span>Centro de ayuda</span>
          </v-tooltip>
        </v-layout> -->

        <!-- <v-layout class="fab-container column" style="bottom: 68px;">
          <Notifications/>
        </v-layout> -->
        <!-- notifications button  -->

        <v-flex v-if="!isPublicRoute && messages && messages.length">
          <v-flex v-for="msg in messages" :key="msg.id">
            <modal :message="msg" />
          </v-flex>
        </v-flex>
      </div>
      <!-- <footer-home2 class="mx-auto cm-footer"/> -->
      <div v-if="!isPublicRoute" v-html="getFooterMenu()" class="footer-menu"></div>


    </v-app>
  </div>
</template>
<script>
import Vue from "vue";
import FooterHome2 from "@/components/General/FooterHome2";
import TopMenu from "@/components/General/TopMenu";
import MenuMobile from "@/components/General/MenuMobile";
import Breadcrumb from "@/components/General/Breadcrumb";
import Loader from "@/components/General/Loader";
import Modal from "@/components/General/Modal";
import ApiMenu from "@/components/General/ApiMenu";
import NotificationsList from "@/components/Notifications/NotificationsList";
import Notifications from "@/components/Notifications/Notifications";
import MaintenanceScreen from "@/components/General/MaintenanceScreen";

import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
let selected_group = "";
let html_json = "";
var group = { id: 3, group: "ASESORIAS SECURITY - SIN SINDICATO" };
let background = "background-image: url()";

export default {
  components: {
    TopMenu,
    FooterHome2,
    MenuMobile,
    Breadcrumb,
    ApiMenu,
    "loading-screen": Loader,
    Modal,
    NotificationsList,
    Notifications,
    MaintenanceScreen
  },
  data() {
    return {
      background: background,
      hidden: false,
      result: [],
      html_json: html_json,
      survey: [],
      selected_group: selected_group,
      group: { id: 3, group: selected_group },
      message_modal: true,
      logged: true,
      windowWidth: screen.width,
      paddingTop: "",
      notificationListOpen: false,
      page: 1,
      view_as: localStorage.getItem("view_as") || "",
      footerHTML: ""
    };
  },
  watch: {
    '$route.path': function (newPath, oldPath) {
      this.updatePaddingTop();

      // Si venimos de una ruta pública a una privada, cargar datos del usuario
      const wasPublic = oldPath === '/login_standard';
      const isPrivateNow = newPath !== '/login_standard' && this.$route.meta.requiresAuth !== false;

      if (wasPublic && isPrivateNow && localStorage.getItem("auth_token")) {
        this.loadUserDataAfterLogin();
      }
    },
    view_as(newVal) {
      if (newVal) {
        this.fetchFooterMenu();
        this.fetchMenu(newVal);
      }
    },
  },
  computed: {
    ...mapState("loading", ["isLoading"]),
    ...mapState("user", ["current_user", "messages"]),
    ...mapState("api_menu", ["menu"]),
    ...mapState("notifications", ["notifications"]),
    ...mapState("api_menu", ["footerMenu"]),
    getClassRouterView() {
      return window.innerWidth <= 1366 && window.innerWidth >= 960 ? "tff-routerview" : "";
    },
    isViewer() {
      return this.current_user && (this.current_user.role.includes('admin') || this.current_user.role.includes('super_admin'))
    },
    isPublicRoute() {
      return this.$route.path === '/login_standard' || this.$route.meta.requiresAuth === false;
    },
  },
  async mounted() {
    // Configurar axios con el token si existe
    this.setupAxiosAuth();

    // No cargar datos si estamos en una ruta pública
    if (this.isPublicRoute) {
      return;
    }

    window.addEventListener('resize', this.updateWindowWidth);
    this.updatePaddingTop();

    try {
      if (localStorage.getItem("auth_token")) {
        this.startLoading();
        await this.fetchFooterMenu();
        const viewAs = localStorage.getItem("view_as") || "null";
        await this.fetchMenu(viewAs);
        await this.fetchData();
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      this.stopLoading();
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowWidth);
    window.removeEventListener("storage", this.updateViewAs);
  },
  methods: {
    ...mapGetters("api_menu", ["getFooterMenu"]),
    ...mapActions("api_menu", ["fetchFooterMenu", "fetchMenu"]),
    ...mapActions("notifications", ["fetchNotifications"]),
    ...mapMutations("notifications", ["setNotifications", "addTotalUnseenNotifications"]),
    ...mapMutations("user", ["setCurrentUser"]),
    ...mapActions("user", [
      "fetchUser",
      "fetchCurrentUser",
      "fetchCurrentUserTemp",
      "fetchCurrentUserParents",
      "fetchUserMessages"
    ]),
    ...mapActions("menus", ["fetchMenuMobile"]),
    ...mapActions("benefits_group", ["fetchBenefitsGroup"]),
    ...mapActions("loading", ["startLoading", "stopLoading"]),
    async getMenuAxios() {
      const { data: htmlJson } = await Vue.axios(
        process.env.VUE_APP_API_URL + `/menus/api_menu_vue`
      );
      this.html_json = htmlJson;
    },
    closeUserMessage(id) {
      this.message_modal = false;
    },
    async changeBackground() {
      const { data: backgroundImg } = await Vue.axios(
        process.env.VUE_APP_API_URL + `/background_img`
      );
      this.background = `background-image: url('${backgroundImg.img}') !important; background-position: center top !important; background-attachment: fixed !important;`;
    },
    see_by_user() {
      this.group.group = this.selected_group;
      this.fetchCurrentUserTemp(this.group);
      this.fetchBenefitsGroup(this.current_user.id);
      setTimeout(this.getMenuAxios, 600);
      this.setCurrentUser(this.current_user);
    },
    browser_detect() {
      let ua = window.navigator.userAgent;
      let ms_ie = /MSIE|Trident/.test(ua);
      if (ms_ie) {
        this.result.push("ie");
        let modals = [
          "tff_indicators_modal",
          "tff_gospel_modal",
          "tff_weather_modal"
        ];
        window.addEventListener(
          "hashchange",
          () => {
            var currentPath = window.location.hash.slice(1);
            if (
              this.$route.path !== currentPath &&
              !modals.includes(currentPath)
            ) {
              this.$router.push(currentPath);
            }
          },
          false
        );
      } else {
        this.result.push("otro");
      }
    },
    onHelpcenter() {
      this.$router.replace('/centro-de-ayuda').catch(()=>{});;
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
      this.updatePaddingTop();
    },
    updatePaddingTop() {
      if (this.windowWidth <= 960 && this.$route.path !== '/' ) {
        this.paddingTop = "padding: 0px 5%; ";
      } else {
        if (this.windowWidth <= 960){
          this.paddingTop = "padding-top: 0px;";
        } else if (this.$route.path === '/') {
          this.paddingTop = "padding-top: 210px;";
        } else {
          if (this.windowWidth > 1500) {
            this.paddingTop = "max-width: 1440px; margin: auto; padding: 210px 0px 50px;";
          } else {
            this.paddingTop = "max-width: 1175px; margin: auto; padding: 210px 0px 50px;";
          }        
        }
      }
    },
    async fetchData() {
      try {
        await this.fetchCurrentUser("null");
        await this.fetchCurrentUserParents("null");
        await this.fetchBenefitsGroup(localStorage.getItem("view_as"));
        await this.fetchUserMessages("null");
        await this.changeBackground();
        this.browser_detect();
        if (this.$vuetify.breakpoint.smAndDown) this.fetchMenuMobile("null");
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
      }
    },
    updateViewAs() {
      this.view_as = localStorage.getItem("view_as") || "";
    },
    async loadUserDataAfterLogin() {
      try {
        this.startLoading();
        await this.fetchFooterMenu();
        const viewAs = localStorage.getItem("view_as") || "null";
        await this.fetchMenu(viewAs);
        window.addEventListener('resize', this.updateWindowWidth);
        this.updatePaddingTop();
        await this.fetchData();
      } catch (error) {
        console.error("Error loading user data after login:", error);
      } finally {
        this.stopLoading();
      }
    },
    setupAxiosAuth() {
      const authToken = localStorage.getItem("auth_token");
      const loginMethod = localStorage.getItem("login_method");

      if (authToken && loginMethod === "bice") {
        // Configurar el header de Authorization para login Bice
        Vue.axios.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;
        console.log("Axios configurado con token Bice");
      }
    },
  },
};
</script>


<style>
@import "assets/animate.css";

  /* @media (max-width: 1367px) and (-ms-high-contrast:none){
    *::-ms-backdrop, .application--wrap {
      min-height: 260vh !important;
    }
  } */

  /* Estilos para IE 11 */
  @media (min-width: 1368px) and (-ms-high-contrast:none){
    .application--wrap {
      min-height: 220vh !important;
    }
  }

@media print {
  #tff_menu_section {
    display: none;
  }

  .v-content{
    /* padding-top: 0 !important; */
  }
  .relationed-posts{
    display: none;
  }

  .theme--light.application {
    background-color: #fff !important;
  }
  .container {
    background-color: #fff !important;
  }

  .fab-container {
    display: none;
  }

  * {
    background-color: white;;
    -webkit-print-color-adjust: exact !important;   /* Chrome, Safari */
    color-adjust: exact !important;                 /*Firefox*/
  }
}
.survey-btn {
  background: white;
}
* {
  font-family: "Titillium Web";
}
.theme--light.application {
  background: #fff !important;
}
/* .container {
  max-width: 1298px !important;
  padding: 24px 0 0 0;
  background-color: #fff;
} */
.fab-container {
  /* @media screen and (min-width: 960px) and (max-width: 1366px){
    position: fixed;
    bottom: -60px !important;
    right: 0px;
    z-index: 8;
  } */

  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 8;
}
.theme--light.v-list {
  background: transparent;
}
.v-menu__activator:hover {
  border-bottom: 3px solid green;
}
.v-toolbar__content,
.v-toolbar__extension {
  height: 55px !important;
}
.profile {
  top: 140px !important;
  left: 650px !important;
}
.search {
  padding-top: 0px;
  margin-top: -20px;
  height: 0px;
}
.v-list a {
  height: 35px;
}
.section_menu {
  font-size: 12px;
  color: #8fca00;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  font-weight: 700;
}
.lingallery {
  background: #edeaea;
}
.btn-security {
  background-color: rgb(33, 22, 81);
  border-color: rgb(33, 22, 81);
  border-radius: 8px;
  padding: 0px 46.5px;
  text-transform: none;
}
.btn-primary-security {
  border-radius: 8px;
  padding: 0px 46.5px;
  height: 30px;
}
.btn-white-security {
  border-radius: 8px;
  padding: 0px 46.5px;
  height: 40px;
  background-color: white;
}
.btn-white-security:hover {
  background: #789c4a !important;
  border-color: #789c4a !important;
  color: white;
  font-weight: 700;
}
.btn-sm-primary-security {
  border-radius: 8px;
  padding: 0px 46.5px;
  height: 25px;
}
.btn-primary-security-menu {
  border-radius: 8px;
  padding: 0px 46.5px;
  height: 30px;
}
.btn-primary-security:hover {
  background: #28385C !important;
  border-color: #28385C !important;
  color: white;
  font-weight: 700;
}
.btn-primary-security-pressed {
  background: #28385C !important;
  border-color: #28385C !important;
  color: white;
  font-weight: 700;
}
.hover {
  cursor: pointer;
}
.no-underline {
  text-decoration: none;
}
.lingallery {
  background: #fff;
}
.caption-security {
  font-size: 11px;
}

.text-10-security {
  font-size: 10px;
}
.text-11-security {
  font-size: 11px;
}
.text-12-security {
  font-size: 12px;
}
.text-13-security {
  font-size: 13px;
}
.text-14-security {
  font-size: 14px;
}
.text-15-security {
  font-size: 15px;
}
.text-16-security {
  font-size: 16px;
}
.text-17-security {
  font-size: 17px;
}
.text-18-security {
  font-size: 	1.125rem;
}
.text-21-security {
  font-size: 21px;
}
.text-24-security {
  font-size: 24px;
}
.text-25-security {
  font-size: 25px;
}
.text-26-security {
  font-size: 26px;
}
.text-27-security {
  font-size: 27px;
}
.text-29-security {
  font-size: 29px;
}
.text-35-security {
  font-size: 35px;
}
.text-39-security {
  font-size: 39px;
}
.green-security {
  color: #638d37;
}
.blue-security {
  /* color: #211850; */
  color: #28385C;
}
.red-security {
  color: #bb263b;
}
.grey-security {
  color: #515151;
}
.btn-active-green {
  background-color: #28385C !important;
  font-weight: 700;
}
.line-heigth-security {
  line-height: 30px;
}
.breadcrumb {
  padding-top: 10px;
}

.j-background-menu {
  z-index: 5;
  background: rgba(0, 0, 0, 0.50);
}

.v-btn--floating .v-icon {
    height: unset;
    width: inherit;
}

@-moz-document url-prefix() {
  .tff-margin-float-icon {
    margin-top: 30px;
  }

  .v-btn--floating .v-icon {
    height: inherit;
    width: inherit;
  }
}

.fixed-celebration-buttons {
  position: sticky; 
  top: 236px; 
}
  .v-btn.v-btn--icon.v-btn--small.theme--light.v-carousel__controls__item{
    color: #919199 !important;
  }
  i.v-icon.fas.fa-circle.theme--light{
    font-size: 8px !important;
  }

  .v-carousel__controls .v-btn {
    border-radius: 50%;
    width: 8px;
    height: 8px;
    min-width: 8px;
  }

  .v-carousel__controls .v-btn--active {
    width: 40px;
    height: 8px;
    border-radius: 20px;
    background-color: #919199;
  }
    .v-carousel__controls .v-btn--active:hover {
    width: 40px;
    height: 8px;
    border-radius: 20px;
    background-color: #919199;
  }
  a.v-tabs__item.v-tabs__item--active{
    max-width: 220px !important;
  }
  .w-100{
    max-width: 1175px;
    padding: 0px;
  }
  @media (max-width: 1175px) {
    .w-100 {
      padding: 0px 5%;
    }
  }

  @media (min-width: 1500px) {
    .w-100 {
      max-width: 1440px;
    }
  }


  /* v2 */
  .text-blue-v2{
    color: #28385C
  }
  .font-blue-bice{
    color: #28385C
  }

  .cm-footer {
    margin-top:auto;
    width: 100%;
  }
  
  .v-list__tile{
    padding: 0 !important
  }
</style>